import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../Style/StoneTypes.css";
import axios from "axios";
import { AppLanguage } from "../context/ApplicationLanguage";

const API_BASE_URL = "https://server-alwaleedstone.onrender.com";

const StoneTypes = () => {
  const [jerusalemStone, setJerusalemStone] = useState([]);
  const [titleJerusalemStone, setTitleJerusalemStone] = useState([]);
  const [natureStone, setNatureStone] = useState([]);
  const [titleNatureStone, setTitleNatureStone] = useState([]);
  const [otherCollection, setOtherCollection] = useState([]);
  const [titleOtherCollection, setTitleOtherCollection] = useState([]);
  const appLang = useContext(AppLanguage);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/stone/jerusalemStone?lang=${appLang.language}`)
      .then((res) => {
        setJerusalemStone(res.data.stones);
        setTitleJerusalemStone(res.data.stoneType);
      })
      .catch((err) => console.log(err));
  }, [appLang.language]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/stone/natureStone?lang=${appLang.language}`)
      .then((res) => {
        setNatureStone(res.data.stones);
        setTitleNatureStone(res.data.stoneType);
      })
      .catch((err) => console.log(err));
  }, [appLang.language]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/stone/otherCollection?lang=${appLang.language}`)
      .then((res) => {
        setOtherCollection(res.data.stones);
        setTitleOtherCollection(res.data.stoneType);
      })
      .catch((err) => console.log(err));
  }, [appLang.language]);

  const renderSection = (title, stones) => (
    <section className="projects-section2">
      <div className="projects-header2">
        <h2 className="section-title2">{title}</h2>
      </div>
      <div className="projects-grid2">
        {stones.map((item) => (
          <Link
            to={`/stone/${item._id}`}
            key={item._id}
            style={{ textDecoration: "none" }}
          >
            <div className="project-card2">
             <div className="image-wrapper2">
  <img
    src={item.mainImage}
    alt={item.stoneName}
    className="project-image2 base-image"
  />
  <img
    src={item.decorativeCollection}
    alt={`${item.stoneName} hover`}
    className="project-image2 hover-image"
  />
</div>

              <p className="project-name2">{item.stoneName}</p>
              
            </div>
          </Link>
        ))}
      </div>
    </section>
  );

  return (
    <div className="home-container2">
      {renderSection(titleJerusalemStone, jerusalemStone)}
      {renderSection(titleNatureStone, natureStone)}
      {renderSection(titleOtherCollection, otherCollection)}
    </div>
  );
};

export default StoneTypes;
